import {
  GET_TEMPLATES,
  COPY_TEMPLATE,
  CREATE_TEMPLATE,
  UPDATE_TEMPLATE,
  GET_TEMPLATE_BY_ID,
  UPDATE_STAGE_FIELDS,
  SET_TEMPLATE_ACTIVE_STATUS,
  GET_VO_TEMPLATES_AND_STAGES,
  GET_CS_TEMPLATES_AND_STAGES,
  UPDATE_CURRENT_STAGE_FOR_DEPARTMENT,
  SET_DEFAULTS_FOR_ACCOUNT,
} from './templates';

import {
  COMPLETE_STAGE,
  UN_COMPLETE_STAGE,
  GET_STAGE_NOTES,
  CREATE_STAGE_NOTE,
  GET_STAGES_TIMELINE,
  GET_STAGES_BY_DEPARTMENT,
  UPLOAD_STAGE_DOCUMENT,
  REMOVE_STAGE_DOCUMENT,
  GET_STAGE_ATTRIBUTE_DOCUMENTS,
} from './stages';

import {
  GET_CLOSE_REASONS,
  CREATE_CLOSE_REASON,
  DELETE_CLOSE_REASON,
  CREATE_CLOSE_REASONS,
  GET_CLOSE_REASONS_OPTIONS,
  UPDATE_CLOSE_REASON_LABEL,
  UPDATE_CLOSE_REASON_STATUS,
} from './closeReasons';

import { bpfDepartmentAPI } from './departments';
import { bpfReportAPI } from './reports';
import { GET_BPF_CHANGELOG_BY_ID, GET_BPF_CHANGELOG_LIST } from './changelog';

export * from './reports';
export * from './stages';
export * from './templates';
export * from './reports';
export * from './closeReasons';
export * from './changelog';

export const bpfAPI = {
  fetchTemplates: GET_TEMPLATES,
  fetchTemplateById: GET_TEMPLATE_BY_ID,
  fetchStagesByDepartment: GET_STAGES_BY_DEPARTMENT,
  fetchVOTemplatesAndStages: GET_VO_TEMPLATES_AND_STAGES,
  fetchCSTemplatesAndStages: GET_CS_TEMPLATES_AND_STAGES,

  completeStage: COMPLETE_STAGE,
  unCompleteStage: UN_COMPLETE_STAGE,
  createTemplate: CREATE_TEMPLATE,
  copyTemplate: COPY_TEMPLATE,
  updateTemplate: UPDATE_TEMPLATE,
  updateStageFields: UPDATE_STAGE_FIELDS,
  setActiveStatus: SET_TEMPLATE_ACTIVE_STATUS,
  setDefaultsForAccount: SET_DEFAULTS_FOR_ACCOUNT,
  updateStageForDepartment: UPDATE_CURRENT_STAGE_FOR_DEPARTMENT,

  fetchCloseReasons: GET_CLOSE_REASONS,
  deleteCloseReason: DELETE_CLOSE_REASON,
  createCloseReason: CREATE_CLOSE_REASON,
  createCloseReasons: CREATE_CLOSE_REASONS,
  updateCloseReasonLabel: UPDATE_CLOSE_REASON_LABEL,
  updateCloseReasonStatus: UPDATE_CLOSE_REASON_STATUS,
  fetchCloseReasonsOptions: GET_CLOSE_REASONS_OPTIONS,

  getStageNotes: GET_STAGE_NOTES,
  createStageNote: CREATE_STAGE_NOTE,
  fetchStagesTimeline: GET_STAGES_TIMELINE,

  uploadStageDocument: UPLOAD_STAGE_DOCUMENT,
  removeStageDocument: REMOVE_STAGE_DOCUMENT,
  getStageAttributeDocuments: GET_STAGE_ATTRIBUTE_DOCUMENTS,

  department: bpfDepartmentAPI,
  report: bpfReportAPI,

  changelogGetById: GET_BPF_CHANGELOG_BY_ID,
  changelogGetList: GET_BPF_CHANGELOG_LIST,
};
